import { render, staticRenderFns } from "./DeleteTransactionsTabs.vue?vue&type=template&id=f1ee4f24&"
import script from "./DeleteTransactionsTabs.vue?vue&type=script&lang=ts&"
export * from "./DeleteTransactionsTabs.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTransactionsTabs.vue?vue&type=style&index=0&id=f1ee4f24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports